@if(isBottomSheet()){
    <app-drag-handle />
}

<div class="my-badge-list">
  <div class="my-badge-list__header">
    <h3 class="my-badge-list__title ci-heading-h3-semibold">
      {{ 'Mis hitos' | translate }}
    </h3>
    
    @if(isBottomSheet()){
      <ci-icon (click)="dismissBottomSheet()" name="close" scale="1x" />
    }
  </div>

  @if(mapMarkers()?.length){
    <div class="my-badge-list__map">
      <app-map-stamp [markers]="mapMarkers()" />
    </div>
  }

  <div class="my-badge-list__body">
    @for(stamp of stampList(); track stamp.id) {
      <div 
        class="my-badge-list__body__stamp-container" 
        [ngClass]="{'active': stamp.str_stamped_at}"
      >
        <!-- <div 
            class="my-badge-list__body__stamp-container__image" 
            [ngStyle]="{
                '--seal-img-url': 'url(' + stamp.image?.[translate.currentLang] + ')',
                'transform': 'rotate(' + stamp.random_rotate + 'deg)'
            }"
        >  -->
        <div 
          class="my-badge-list__body__stamp-container__image" 
          [ngStyle]="{
              'transform': 'rotate(' + stamp.random_rotate + 'deg)'
          }"
        > 
          <img [src]="stamp.image?.[translate.currentLang]" />
        </div>

        <div class="my-badge-list__body__stamp-container__content">
          <span class="ci-heading-h5-s-semibold">
            {{ stamp.address?.[translate.currentLang] }}
          </span>
          @if (stamp.str_stamped_at){
            <span class="ci-paragraph-p2-regular">
              {{ 'Obtenido el' | translate }} {{ stamp.str_stamped_at }}
            </span>
          }
        </div>
      </div>
    }
  </div>
</div>
